import { useSelector, useDispatch } from "react-redux";
import { useIntl } from "react-intl";
import { useEffect, useState } from "react";
//Controls
import { Modal, ModalBody, ModalFooter, Button } from "@gpstrackit/react-controls";

import { JsonView, allExpanded, darkStyles, defaultStyles } from 'react-json-view-lite';
import 'react-json-view-lite/dist/index.css';

import { copyToClipboard } from 'Core/data/Helpers';

//Actions
import {
    systemAlertLastReadingInfoOpenModal,
    systemAlertLastReadingInfoRequest,
    clearRedux,
} from 'Redux/actions';

const LastReadingModal = (props) => {
    const dispatch = useDispatch();
    const { messages } = useIntl();

    const { openModal, device, loading, result } = useSelector(state => state.systemAlertLastReadingInfoRedux);
    const [lastReadingInfo, setLastReadingInfo] = useState(null);
    const closeModal = () => {
        dispatch(systemAlertLastReadingInfoOpenModal(false));
        dispatch(clearRedux("SYSTEM_ALT_LAST_READING_INFO"));
        setLastReadingInfo(null)
    }

    useEffect(() => {
        if (openModal) {
            dispatch(systemAlertLastReadingInfoRequest(device))
        }
    }, [openModal])

    useEffect(() => {
        if (result) {
            let data = null;
            try {
                data = result ? JSON.parse(result) : null;
            } catch (error) { }
            dispatch(clearRedux("SYSTEM_ALT_LAST_READING_INFO", { result: null }));
            setLastReadingInfo(data);
        }
    }, [result])

    return (
        <Modal
            open={openModal}
            title={messages['system_alert_logs_tab_show_last_reading_info']}
            position="right"
            size="small"
            handleClose={closeModal}
            loading={loading}
        >
            <ModalBody>
                <div style={{ marginTop: 10, marginBottom: 10 }}>
                    {lastReadingInfo ?
                        <JsonView data={lastReadingInfo} shouldExpandNode={allExpanded} style={defaultStyles} />
                        : <div style={{ display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'center', marginTop: 10, opacity: 0.5 }}>{messages['common_no_information_to_display']}</div>}
                </div>
            </ModalBody>
            <ModalFooter>
                <Button
                    onClick={(e) => {
                        copyToClipboard(JSON.stringify(lastReadingInfo), messages['common_copied'])
                    }}
                >
                    {messages['show_raw_data_modal_copy']}
                </Button>
                <Button
                    className="btn-dark-blue"
                    onClick={() => closeModal()}
                >
                    {messages['close']}
                </Button>
            </ModalFooter>
        </Modal>
    )
}
export default LastReadingModal;